import clsx from "clsx";
import GenericDataTable, {
  GenericDataTableProps,
} from "../../DataTable/DataTable";
import CrudHeader, { CrudHeaderProps } from "./CrudHeader";
import CrudCards, { type CardActions, type CardGridColumns } from "./CrudCards";

type CrudViewProps<T> = GenericDataTableProps<T> &
  CrudHeaderProps & {
    header?: React.ReactNode;
    mode?: "table" | "cards";
    renderCard?: (item: T, actions: CardActions) => React.ReactNode;
    gridColumns?: CardGridColumns;
  };

function CrudContent<T extends Record<string, any>>({
  mode,
  ...props
}: CrudViewProps<T>) {
  switch (mode) {
    case "table":
      return <GenericDataTable<T> {...props} />;
    case "cards":
      return <CrudCards<T> {...props} />;
    default:
      return <GenericDataTable<T> {...props} />;
  }
}

function CrudView<T extends Record<string, any>>({
  header,
  mode = "table",
  ...props
}: CrudViewProps<T>) {
  return (
    <div
      className={clsx(
        "mx-auto max-w-full text-slate-500 flex-1 flex flex-col",
        props.compact ? "gap-0" : "gap-6"
      )}
    >
      {header !== undefined ? header : <CrudHeader {...props} />}

      <CrudContent<T> mode={mode} {...props} />
    </div>
  );
}

export default CrudView;
export type { CrudViewProps };
